import { ChartPlotColors } from "../constants/chartColors";

// match normalization used across charts
const normDir = (d) => {
  const s = (d ?? "").trim();
  return s !== "" ? s : "Unknown";
};

const isSiteExcluded = (arr, site) => Array.isArray(arr) && arr.includes(site);
const isDirectionExcluded = (arr, dir) =>
    Array.isArray(arr) && arr.includes(normDir(dir));
const isSiteDirectionExcluded = (arr, sdn) =>
    Array.isArray(arr) && arr.includes(String(sdn || "").trim());

/**
 * Share pie: Not-overloaded vs Overloaded
 * Expects: { [locationId]: { dailyStats: [...] } }
 */
export function prepareOverloadSharePie(
    siteDataMap = {},
    excludedSites = [],
    excludedDirections = [],
    excludedSiteDirectionNames = [] // NEW: exact match against `row.siteDirectionName`
) {
  let totalOverloaded = 0;
  let totalNotOverloaded = 0;

  Object.entries(siteDataMap || {}).forEach(([, data]) => {
    const rows = Array.isArray(data?.dailyStats) ? data.dailyStats : [];
    for (const row of rows) {
      if (isSiteExcluded(excludedSites, row?.locationId)) continue;
      if (isDirectionExcluded(excludedDirections, row?.direction)) continue;
      if (isSiteDirectionExcluded(excludedSiteDirectionNames, row?.siteDirectionName)) continue;

      totalOverloaded += row?.numAllOverloadedVehicles ?? 0;
      totalNotOverloaded += row?.numNotOverloadedVehicles ?? 0;
    }
  });

  return {
    labels: [
      "dashboards_view.kpi1.pie_overload_share.no_overload",
      "dashboards_view.kpi1.pie_overload_share.overload",
    ],
    values: [totalNotOverloaded, totalOverloaded],
    colors: [ChartPlotColors.NO_OVERLOAD, ChartPlotColors.OVERLOADED],
  };
}

/**
 * Type pie: breakdown of overloaded by type (axle | mass | both)
 * Expects: { [locationId]: { dailyStats: [...] } }
 */
export function prepareOverloadTypePie(
    siteDataMap = {},
    excludedSites = [],
    excludedDirections = [],
    excludedSiteDirectionNames = [] // NEW: exact match against `row.siteDirectionName`
) {
  let onlyAxle = 0;
  let onlyMass = 0;
  let both = 0;

  Object.entries(siteDataMap || {}).forEach(([, data]) => {
    const rows = Array.isArray(data?.dailyStats) ? data.dailyStats : [];
    for (const row of rows) {
      if (isSiteExcluded(excludedSites, row?.locationId)) continue;
      if (isDirectionExcluded(excludedDirections, row?.direction)) continue;
      if (isSiteDirectionExcluded(excludedSiteDirectionNames, row?.siteDirectionName)) continue;

      onlyAxle += row?.numAxleLoadOverLimit ?? 0;
      onlyMass += row?.numTotalMassOverLimit ?? 0;
      both += row?.numMassAndAxleOverLimit ?? 0;
    }
  });

  return {
    labels: [
      "dashboards_view.kpi1.pie_overload_types.only_axle",
      "dashboards_view.kpi1.pie_overload_types.only_mass",
      "dashboards_view.kpi1.pie_overload_types.both",
    ],
    values: [onlyAxle, onlyMass, both],
    colors: [
      ChartPlotColors.AXLE_ONLY,
      ChartPlotColors.MASS_ONLY,
      ChartPlotColors.BOTH,
    ],
  };
}
